import store from '@/store';
import { SET_TOKEN, SET_USER } from '@/store/constants';
import * as msal from '@azure/msal-browser';

export const MSAL = {
  msalInstance: null,
  initialized: false,
  async init() {
    if (this.msalInstance) return this.msalInstance;
    const msalInstance = new msal.PublicClientApplication({
      auth: {
        clientId: process.env.VUE_APP_MICROSOFT_SSO_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.VUE_APP_MICROSOFT_SSO_TENANT_ID}`,
        redirectUri: `${window.location.origin}/login`,
      },
      cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true
      }
    });
    await msalInstance.initialize();
    this.msalInstance = msalInstance;
    const currentAccount = this._getCurrentAccount();
    if(!currentAccount) {
      store.commit(SET_TOKEN,'')
      store.commit(SET_USER,null,{ root: true })
    }
    this.initialized = true;
    return this.msalInstance;
  },
  async handleRedirect() {
    try {
      await this.waitForInitialization();
      const result = await this.msalInstance.handleRedirectPromise();
      if (result) {
        this.msalInstance.setActiveAccount(result.account);
        return this.getAccessToken();
      }
    } catch (e) {
      return null
    }
    return null;
  },
  async login() {
    await this.waitForInitialization();
    const currentAccount = this._getCurrentAccount();
    if(currentAccount) return this.getAccessToken();
    await this.msalInstance.loginRedirect({
      scopes: ['openid', 'profile'],
      extraScopesToConsent: [`api://${process.env.VUE_APP_MICROSOFT_SSO_CLIENT_ID}/access_as_user`],
      prompt: 'select_account',
    });
  },
  async logout() {
    await this.waitForInitialization();
    const currentAccount = this._getCurrentAccount();
    if(!currentAccount) throw new Error('No active account found');
    await this.msalInstance.logoutRedirect({
      account: currentAccount,
      postLogoutRedirectUri: `${window.location.origin}/login`,
    });
  },
  async getAccessToken() {
    await this.waitForInitialization();
    const currentAccount = this._getCurrentAccount();
    if(!currentAccount) throw new Error('No active account found');
    const response = await this.msalInstance.acquireTokenSilent({
      scopes: [`api://${process.env.VUE_APP_MICROSOFT_SSO_CLIENT_ID}/access_as_user`],
      account: currentAccount
    });
    return this._formatResponse(response);
  },
  _getCurrentAccount() {
    let currentAccount = this.msalInstance.getActiveAccount();
    if (!currentAccount) {
      const accounts = this.msalInstance.getAllAccounts();
      if (accounts.length > 0) currentAccount = accounts[0];
    }
    return currentAccount;
  },
  _formatResponse(response) {
    return {
      accessToken: response.accessToken || null,
      user: {
        id: response.account.homeAccountId,
        name: response.account.name,
        email: response.account.username,
        claims: response.account.idTokenClaims
      }
    };
  },
  waitForInitialization() {
    return new Promise((resolve,reject) => {
      const checkInitialized = () => {
        if (this.initialized) resolve();
        else setTimeout(checkInitialized, 100);
      };
      setTimeout(() => reject('MSAL not initialized'), 10 * 1000);
      checkInitialized();
    });
  }
};